<template>
  <va-edit-layout>
    <about-incocegla-form :id="id" :title="title" :item="item"></about-incocegla-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
